<template>
    <div class="apprentice-simple-card dashboard-invites-widget">
        <div class="component-title">
            <h5 class="title">{{ $t('dashboard.your_to_dos') }}</h5>
        </div>

        <!--        groepjesmaaktool uitnodigingen-->
        <div
            class="invites"
            v-if="invites.length && $authUser.isTeacher()">
            <div
                class="invite"
                v-for="invite in invites">
                <div class="icon d-none d-lg-block"><i class="fad fa-fw fa-user"></i></div>
                <div class="title">
                    {{ invite.name }}
                    <div class="invite-type muted-text">{{ $t('dashboard.approve_request') }}</div>
                </div>
                <div class="invite-show">
                    <b-button
                        class="btn-open"
                        v-b-tooltip="$t('common.view')"
                        variant="primary-icon-only"
                        href="#">
                    </b-button>
                </div>
                <a
                    class="clickable"
                    :href="'/grouppair/teacher/check/' + invite.group_id"></a>
            </div>
        </div>

        <!--        groepjesmaaktool uitnodigingen-->
        <div
            class="invites"
            v-else-if="invitesEmpty.length">
            <div
                class="invite"
                v-for="invite in invitesEmpty">
                <div class="icon d-none d-xl-flex">
                    <i
                        class="fad fa-fw"
                        :class="invite.status === 1 ? 'fa-exclamation-triangle recheck' : 'fa-user-plus add'"></i>
                </div>
                <div class="title">
                    {{ invite.group.name }}
                    <div class="invite-type muted-text">{{ $t('dashboard.submit_request') }}</div>
                </div>
                <div class="invite-show">
                    <b-button
                        class="btn-open btn-icon-only"
                        v-b-tooltip="'Bekijken'"
                        variant="primary-icon-only"
                        href="#">
                    </b-button>
                </div>

                <a
                    class="clickable"
                    :href="
                        invite.group_pair_id === null
                            ? `/grouppair/create/${invite.group_id}`
                            : `grouppair/edit/${invite.group_pair_id}`
                    "></a>
            </div>
        </div>

        <span
            v-if="surveyPeersIn.length || surveysIn.length || (arSkillTreeInvitesIn && arSkillTreeInvitesIn.length)"
            >{{ $t('dashboard.invite_rubrics') }}</span
        >
        <div
            class="rubric-surveys"
            v-if="surveysIn.length">
            <div v-for="survey in surveysIn">
                <div class="rubric-invite">
                    <div class="btn-check-list icon remove-icon-margin d-none d-xl-flex"></div>
                    <div class="title">
                        {{ survey.skill && survey.skill.name ? survey.skill.name : '' }}
                        <div class="invite-type muted-text">
                            {{ $t('dashboard.rubrics_fill') }} {{ survey.rubric_survey_users.length }}
                            {{ $t('dashboard.rubrics_fill_in') }}
                        </div>
                    </div>
                    <div class="invite-show">
                        <b-button
                            class="btn-open btn-icon-only"
                            v-b-tooltip="$t('common.view')"
                            variant="primary-icon-only"
                            href="#">
                        </b-button>
                    </div>

                    <a
                        class="clickable"
                        :href="getSurveyLink(survey)"></a>
                </div>
            </div>
        </div>
        <div
            class="rubrics-invites"
            v-if="surveyPeersIn.length">
            <div v-for="survey in surveyPeersIn">
                <!--                normal rubric survey-->
                <div v-if="survey.rubric_survey_id && survey.rubric_forms.length">
                    <div class="rubric-invite">
                        <div class="btn-check-list icon remove-icon-margin d-none d-xl-flex"></div>
                        <div class="title">
                            {{ survey.rubric_survey.name }}
                            <div class="invite-type muted-text">{{ $t('dashboard.rubrics_fill_in_rubric') }}</div>
                        </div>
                        <div class="invite-show">
                            <b-button
                                class="btn-open btn-icon-only"
                                v-b-tooltip="$t('common.view')"
                                variant="primary-icon-only"
                                href="#">
                            </b-button>
                        </div>

                        <a
                            class="clickable"
                            :href="getPeerLink(survey)"></a>
                    </div>
                </div>

                <!--                rubric survey peer-->
                <div
                    v-else-if="
                        survey.rubric_survey_user_id &&
                        survey.rubric_survey_user &&
                        survey.rubric_survey_user.rubric_forms.length
                    ">
                    <div class="rubric-invite">
                        <div class="btn-check-list icon remove-icon-margin d-none d-xl-flex"></div>
                        <div class="title">
                            {{ survey.rubric_survey_user.rubric_survey.name }}
                            <div class="invite-type muted-text">
                                {{ $t('dashboard.rubrics_fill_in_for') }}
                                {{ survey.rubric_survey_user.user.full_name }} in
                            </div>
                        </div>
                        <div class="invite-show">
                            <b-button
                                class="btn-open btn-icon-only"
                                v-b-tooltip="$t('common.view')"
                                variant="primary-icon-only"
                                href="#">
                            </b-button>
                        </div>
                        <a
                            class="clickable"
                            :href="getOtherPeerLink(survey)"></a>
                    </div>
                </div>

                <div v-if="survey.assignment_rubric_id && survey.rubric_forms.length">
                    <div class="rubric-invite">
                        <div class="btn-check-list icon remove-icon-margin d-none d-xl-flex"></div>
                        <div class="title">
                            {{ survey.assignment_rubric.assignment.name }}
                            <div class="invite-type muted-text"></div>
                        </div>
                        <div class="invite-show">
                            <b-button
                                class="btn-open btn-icon-only"
                                v-b-tooltip="$t('common.view')"
                                variant="primary-icon-only"
                                href="#">
                            </b-button>
                        </div>

                        <a
                            class="clickable"
                            :href="getAssignmentPeerLink(survey)"></a>
                    </div>
                </div>

                <div v-else-if="survey.assignment_rubric_user_id && survey.assignment_rubric_user.rubric_forms.length">
                    <div class="rubric-invite">
                        <div class="btn-check-list icon remove-icon-margin d-none d-xl-flex"></div>
                        <div class="title">
                            {{ $t('dashboard.rubrics_fill_in_for') }}
                            {{ survey.assignment_rubric_user.user.full_name }}, {{ $t('dashboard.rubrics_about') }}
                            {{ survey.assignment_rubric_user.assignment_rubric.assignment.name }}
                            <div class="invite-type muted-text">
                                {{ $t('dashboard.complete_rubrics_for_this_assignment') }}
                            </div>
                        </div>
                        <div class="invite-show">
                            <b-button
                                class="btn-open btn-icon-only"
                                v-b-tooltip="$t('common.view')"
                                variant="primary-icon-only"
                                href="#">
                            </b-button>
                        </div>

                        <a
                            class="clickable"
                            :href="getAssignmentPeerLink(survey.assignment_rubric_user)"></a>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="skill-tree-invites"
            v-if="arSkillTreeInvitesIn && arSkillTreeInvitesIn.length">
            <div v-for="invite in arSkillTreeInvitesIn">
                <div
                    class="rubric-invite"
                    @click="openSkillPicker(invite)">
                    <div class="btn-check-list icon remove-icon-margin d-none d-xl-flex"></div>
                    <div class="title">
                        {{ $t('dashboard.rubrics_fill_in_for_assignment') }}: {{ invite.assignment.name }}
                        {{ $t('dashboard.rubrics_fill_in_of') }} {{ invite.project.group.name }}
                        {{ $t('dashboard.rubrics_fill_in_2') }}
                        <div class="invite-type muted-text">
                            {{ $t('dashboard.choose_a_skill_to_complete_rubrics') }}
                        </div>
                    </div>
                    <div class="invite-show">
                        <b-button
                            class="btn-open btn-icon-only"
                            v-b-tooltip="$t('common.view')"
                            variant="primary-icon-only"
                            href="#">
                        </b-button>
                    </div>
                </div>
            </div>
            <design-2021-assignment-skill-tree-skill-picker-component
                ref="rubric-skill-picker"
                :invite="true"
                @chosen-skill-ids="submitSkillsForAssignmentRubric">
            </design-2021-assignment-skill-tree-skill-picker-component>
        </div>

        <div
            class="rubric-surveys"
            v-if="profileChoiceSurveyUsersIn && profileChoiceSurveyUsersIn.length">
            <div v-for="profileChoiceSurveyUser in profileChoiceSurveyUsersIn">
                <div class="rubric-invite">
                    <div class="btn-check-list icon remove-icon-margin d-none d-xl-flex"></div>
                    <div class="title">
                        {{ $t('dashboard.profile_choice') }}
                        <div class="invite-type muted-text">{{ $t('dashboard.enter_profile_choice') }}</div>
                    </div>
                    <div class="invite-show">
                        <b-button
                            class="btn-open btn-icon-only"
                            v-b-tooltip="$t('common.view')"
                            variant="primary-icon-only"
                            href="#">
                        </b-button>
                    </div>

                    <a
                        class="clickable"
                        :href="getProfileChoiceSurveyLink(profileChoiceSurveyUser.id)"></a>
                </div>
            </div>
        </div>

        <div
            class="test-responses"
            v-if="unfinishedTestResponsesIn.length">
            Tests
            <div v-for="testResponse in unfinishedTestResponsesIn">
                <div class="rubric-invite">
                    <div class="btn-clipboard-user icon remove-icon-margin d-none d-xl-flex"></div>
                    <div class="title">
                        {{ testResponse.test_issuing.test.title }}
                        <div class="invite-type muted-text">{{ $t('dashboard.enter_test') }}</div>
                    </div>
                    <div class="invite-show">
                        <b-button
                            class="btn-open btn-icon-only"
                            v-b-tooltip="'Bekijken'"
                            variant="primary-icon-only"
                            href="#">
                        </b-button>
                    </div>

                    <a
                        class="clickable"
                        :href="getTestLink(testResponse)"></a>
                </div>
            </div>
        </div>

        <!--        als er geen uitnodigingen zijn-->
        <div
            class="not-found with-header empty-invites-list"
            v-if="noTodos">
            <i class="fad fa-4x fa-thumbs-up btn-primary-icon-only"></i><br /><br />
            <div class="alert-notice">{{ $t('dashboard.no_to_dos_found') }}</div>
        </div>
    </div>
</template>

<script>
import Design2021AssignmentSkillTreeSkillPickerComponent from '../../../assignment/show/modals/design-2021-assignment-skill-tree-skill-picker-component.vue';

export default {
    name: 'design-2021-dashboard-project-invites-widget-component',
    components: { Design2021AssignmentSkillTreeSkillPickerComponent },
    props: {
        invitesIn: [Array, Object],
        profileChoiceSurveyUsersIn: [Array, Object],
        surveyPeersIn: [Array, Object],
        surveysIn: Array,
        groupsIn: Array,
        arSkillTreeInvitesIn: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },
        unfinishedTestResponsesIn: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            invites: this.invitesIn.filter((invite) => invite.status !== 2),
            invitesEmpty: this.invitesIn.filter(
                (invite) => (invite.status === 1 || invite.status === null) && invite.status !== 3,
            ),
            currentSkillPickerInvite: null,
        };
    },
    computed: {
        noTodos() {
            return (
                !this.invites.length &&
                !this.surveyPeersIn.length &&
                (!this.profileChoiceSurveyUsersIn || !this.profileChoiceSurveyUsersIn.length) &&
                !this.arSkillTreeInvitesIn.length &&
                !this.unfinishedTestResponsesIn.length
            );
        },
    },
    methods: {
        openSkillPicker(invite) {
            this.currentSkillPickerInvite = invite;
            this.$refs['rubric-skill-picker'].show(invite.assignment);
        },
        submitSkillsForAssignmentRubric(skill_ids) {
            this.alert;
            let data = {
                invite_id: this.currentSkillPickerInvite.id,
                skill_ids: skill_ids,
                assignment_id: this.currentSkillPickerInvite.assignment_id,
                project_id: this.currentSkillPickerInvite.project_id,
            };
            this.axios.post(this.routes.submitSkillsForAssignmentRubric(), data).then(
                (response) => {
                    this.alert.success();
                    window.location.href = this.routes.assignmentRubricEdit(response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        getPeerLink(rubric_survey_user) {
            return this.routes.rubricSurveyUserEdit(rubric_survey_user.id);
        },
        getTestLink(testResponse) {
            return this.routes.testResponse(testResponse.id);
        },
        getOtherPeerLink(survey) {
            return this.routes.rubricSurveyUserEdit(survey.rubric_survey_user_id);
        },
        getAssignmentPeerLink(assignmentRubricUser) {
            return this.routes.assignmentRubricEdit(assignmentRubricUser.id);
        },
        getSurveyLink(rubric_survey) {
            return this.routes.rubricSurveyUserEdit(rubric_survey.rubric_survey_users[0].id);
        },
        getProfileChoiceSurveyLink(profileChoiceSurveyUserId) {
            return this.routes.profileChoiceCreate(profileChoiceSurveyUserId);
        },
    },
};
</script>

<style scoped lang="scss">
.dashboard-invites-widget {
    .info-text {
        color: $text-muted-color;
        font-size: $default-font-size;
    }

    .info-text,
    .invite,
    .rubric-invite {
        margin-bottom: map-get($grid-gutter-spacing, 'ten');
    }

    .rubric-invite {
        .btn:before {
            margin-right: 0;
        }
    }

    .invite,
    .rubric-invite {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        font-size: 1.3125rem;
        position: relative;
        padding-top: map-get($grid-gutter-spacing, 'ten');

        .icon {
            align-self: center;
            padding: map-get($grid-gutter-spacing, 'ten');
            background: $secondary-background-color;
            border-radius: $border-radius-content;
            color: $primary;
        }

        .title {
            font-size: $default-font-size;
            font-family: $headings-font-family;
            line-height: 1;
            align-self: center;
        }

        .invite-show,
        .invite-action {
            align-self: center;
            margin-left: auto;

            .btn {
                font-size: 1.3125rem;
            }
        }

        &:hover {
            cursor: pointer;

            .icon {
                color: $inverse-info;
            }

            .title {
                font-weight: $font-weight-medium;
                color: $primary;
            }

            .invite-show .btn {
                color: $nav-link-color;
            }
        }
    }

    .rubric-invites {
        margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .invite,
    .rubric-invite {
        .title {
            margin-right: map-get($grid-gutter-spacing, 'ten');
        }
    }

    .page-wrapper.navbar-toggled {
        .invite,
        .rubric-invite {
            .title {
                margin-left: map-get($grid-gutter-spacing, 'ten');
            }

            .icon {
                display: flex !important;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .dashboard-invites-widget {
        .invite,
        .rubric-invite {
            .title {
                margin-left: map-get($grid-gutter-spacing, 'fifteen');
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
}
</style>
